/**
 * This Mutation is used to create a child using the parent add child flow
 */
import gql from "graphql-tag";
import * as React from "react";

import type {ApolloResult} from "@khan/data-gql-apollo";
import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import ApolloMutation from "#data-access/gql/apollo-mutation.tsx";

const DATA_MUTATION: GqlOperation<Data, Variables> = gqlOp(gql`
    mutation updateUnderAgeGateParentEmailMutation($parentEmail: String!) {
        updateUnderAgeGateParentEmail(parentEmail: $parentEmail) {
            user {
                id
                kaid
                underAgeGate {
                    parentEmail
                }
            }
            error {
                code
            }
        }
    }
`);

export const MUTATION_FOR_TESTS = DATA_MUTATION;

type Data = {
    user:
        | {
              id: string;
              kaid: string;
              underAgeGate:
                  | {
                        parentEmail: string;
                    }
                  | null
                  | undefined;
          }
        | null
        | undefined;
    error:
        | {
              code: string;
          }
        | null
        | undefined;
};

type Variables = {
    parentEmail: string;
};

export type UpdateUnderAgeGateParentEmail = (
    arg1: string,
) => Promise<ApolloResult<Data> | null | undefined>;

type Props = {
    children: (arg1: {
        updateParentEmail: UpdateUnderAgeGateParentEmail;
        isLoading: boolean;
    }) => React.ReactNode;
    onCompleted?: (data?: Data | null | undefined) => void;
    onError: (arg1: Error) => void;
};

export default class UpdateUnderAgeGateParentEmailMutation extends React.Component<Props> {
    render(): React.ReactNode {
        const {children, onCompleted, onError} = this.props;

        return (
            <ApolloMutation
                mutation={DATA_MUTATION}
                onCompleted={onCompleted}
                onError={onError}
            >
                {(update, {loading}) =>
                    children({
                        updateParentEmail: (parentEmail) =>
                            update({
                                variables: {
                                    parentEmail,
                                },
                            }),
                        isLoading: loading,
                    })
                }
            </ApolloMutation>
        );
    }
}
